import { PREVIEW_CATALOG } from './nativePreviewModel'
import { GamePageWorkspace } from './GamePageWorkspace'
import { HomeVariationWorkspace } from './HomeVariationWorkspace'

export function ExperienceWorkspace(props) {
  // Opening an editor is read-only; the workspace materializes the default on the first edit.
  const experience = props.workspace.experience
  const catalog = props.workspace.previewCatalog || PREVIEW_CATALOG
  return props.surface === 'events'
    ? <GamePageWorkspace {...props} />
    : <HomeVariationWorkspace {...props} experience={experience} catalog={catalog} />
}
